<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getTasks">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addTasks">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="tasks" highlight-current-row v-loading="listLoading" style="width: 100%;" :height="bodyHeight-220">
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="taskName" label="任务名称" min-width="200">
      </el-table-column>
      <el-table-column prop="cron" label="时间表达式" min-width="200">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center" >
        <template scope="scope">
          <el-switch v-model="scope.row.isActive"
                     active-color="#13ce66"
                     inactive-color="#ff4949"
                     @change="changeStatus($event,scope.row)"
                     >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" min-width="200" :formatter="formatdate">
      </el-table-column>
      <el-table-column label="操作" width="350">
        <template scope="scope">
          <el-button size="small" @click="editTask(scope.$index, scope.row)">编辑</el-button>
          <el-button size="small" @click="editModel(scope.row)">模型</el-button>
          <el-button type="danger" size="small" @click="delTask(scope.$index, scope.row)">删除</el-button>
          <el-button size="small" @click="executeTask(scope.row)" type="success" icon="el-icon-caret-right">执行</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog :title="taskTitle" :visible.sync="addFormVisible" :close-on-click-modal="false" top="5vh" width="80%">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <el-form-item label="任务名称" prop="taskName">
          <el-input v-model="addForm.taskName"></el-input>
        </el-form-item>
        <el-form-item label="时间表达式" prop="cron">
          <el-input v-model="addForm.cron"></el-input>
        </el-form-item>
        <el-form-item label="代理" prop="agentIds">
          <el-select v-model="addForm.agentIds" multiple placeholder="请选择">
            <el-option v-for="item in agents"
                       :key="item.agentId"
                       :label="item.name"
                       :value="item.agentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="脚本" prop="script">
          <el-input type="textarea" :rows="15" v-model="addForm.script"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveTask" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
export default {
  name: 'taskmanage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      sels: [],
      listLoading: false,
      sortname: 'dataSourceId',
      sorttype: 'ascending',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      tasks: [],
      databases: [],
      taskTitle: '新增',
      isEditModel: false,
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        cron: [
          { required: true, message: '请输入时间表达式', trigger: 'blur' }
        ],
        agentIds: [
          { required: true, message: '请选择代理', trigger: 'blur' }
        ],
        script: [
          { required: true, message: '请输入脚本', trigger: 'blur' }
        ]
      },
      addForm: {
        taskName: "",
        cron: "",
        agentIds: "",
        script: ""
      },
      agents: []

    }
  },
  methods: {     
    formatdate: function (row, col, value) {
      return new Date(value).Format('yyyy-MM-dd')
    },
    // 获取列表
    getTasks: function () {
      let para = {
        agentId: this.$route.params.agentId,
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }
      this.$ajax({
        url: 'api/DataCollect/GetTasks',
        method: 'get',
        //data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.tasks = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    
    pageChange: function(val) {
      this.pageno = val
      this.getTasks()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getTasks()
    },
    // 删除代理
    delTask: function (index,row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        this.$ajax({
          loadingName: "listLoading",
          url: `api/DataCollect/DeleteTask?taskId=${row.taskId}`
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTasks()
        })
      }).catch(() => {
      })
      }
      ,
    addTasks: function () {
      this.addFormVisible = true
      this.getAgents()
      this.addForm = {
        taskName: "",
        cron: "",
        agentIds: "",
        script: ""
      }
      this.$refs.addForm.resetFields()
    },
    editTask: async function (index, row) {
      this.addFormVisible = true
      this.addForm = {
        taskName: "",
        cron: "",
        agentIds: "",
        script: ""
      }
      await this.getAgents()
      this.$ajax({
      url: 'api/DataCollect/GetTask?taskId=' + row.taskId,
      method: 'get',       
      loadingName: 'listLoading',
        success: (d) => {
          if (d && typeof d.agentIds ==="string")
             d.agentIds = eval("["+d.agentIds+"]")
          this.addForm = d
      }
      }).then(() => {
        this.taskTitle = '编辑'
        this.isEditModel = true
        this.$refs.addForm.resetFields()
      })
    },
    saveTask: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm)
          if (Array.isArray(para.agentIds))
            para.agentIds = para.agentIds.join(",")
          this.$ajax({
            url: 'api/DataCollect/SaveTask',
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.$refs['addForm'].resetFields()
              this.addFormVisible = false
              this.getTasks()
            }
          })
        }
      })
    },
    getAgents: async function () {
        await this.$ajax({
        url: 'api/DataCollect/GetAgents',
        method: 'get',
        loadingName: 'listLoading',
        success: (d, r) => {
          this.agents = d
        }
      })
    },
    changeStatus: function ($event,row) {
      let para = row.taskId
      let url = ""
      if ($event)
        url = 'api/DataCollect/EnableTask?taskId=' + para
      else
        url = 'api/DataCollect/DisableTask?taskId=' + para
      this.$ajax({
        url: url,
        loadingName: 'listLoading',
        success: (d) => {
          this.getTasks()
        }
      })
    },
    editModel: function (row) {
        this.$router.push({ name: '模型编辑', params: { taskId: row.taskId } })
    },
    executeTask: function (row) {
      this.$router.push({ name: '任务执行', params: { taskId: row.taskId } })
    }
  },
  mounted() {
    this.getTasks()    
  }
}
</script>

<style>
  i.Success {
    color: #67C23A
  }

  i.Info {
    color: #909399
  }

  .el-transfer-panel {
    width: 400px !important;
  }
</style>